// extracted by mini-css-extract-plugin
module.exports = {"timePriceContainer":"TimePrice-module--timePriceContainer--l6mqB"};